import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";

/* =========================
   STYLES
========================= */

const styles = StyleSheet.create({
    page: {
        // paddingTop: 100,
        // paddingBottom: 60,
        // paddingHorizontal: 30,
        // fontSize: 9,
         padding: 20,
        fontSize: 9,
    },

    headerWrapper: {
        position: "absolute",
        top: 20,
        left: 20,
        right: 20,
        height: 60,
        justifyContent: "center",
        alignItems: "center",
    },
    headerImage: {
        width: "100%",
        height: 60,
        objectFit: "contain",
    },

    footerWrapper: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: 50,
    },

    footerImage: {
        width: "100%",
        height: "100%",
    },

    reportTitle: {
        textAlign: "center",
        fontSize: 12,
        marginBottom: 15,
        fontWeight: "bold",
    },

    projectBox: {
        marginBottom: 15,
    },

    projectHeader: {
        backgroundColor: "#eaeaea",
        padding: 5,
        borderWidth: 1,
        borderColor: "#000",
    },

    overheadBox: {
        marginTop: 8,
        borderWidth: 1,
        borderColor: "#000",
        padding: 5,
    },

    overheadTitle: {
        marginBottom: 4,
        marginTop: 6,
        fontWeight: "bold",
    },

    table: {
        width: "100%",
        marginTop: 4,
    },

    tableRow: {
        flexDirection: "row",
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#000",
    },

    /* FIXED WIDTHS - IMPORTANT */
    colSl: {
        width: 40,
        padding: 3,
        textAlign: "center",
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colDate: {
        width: 80,
        padding: 3,
        textAlign: "center",
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colComment: {
        flex: 1,
        padding: 3,
        textAlign: "center",
        borderRightWidth: 1,
        borderColor: "#000",
    },


    colAmount: {
        width: 70,
        padding: 3,
        textAlign: "center",
    },
    colsSl: {
        width: 40,
        padding: 3,
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colsDate: {
        width: 80,
        padding: 3,
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colsComment: {
        flex: 1,
        padding: 3,
        borderRightWidth: 1,
        borderColor: "#000",
    },
    colsAmount: {
        width: 70,
        padding: 3,
        textAlign: "right",
    },
    tableHeaderText: {
        fontWeight: "bold",
        textAlign: "center",
    },

    totalRow: {
        flexDirection: "row",
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#000",
    },

    totalLabel: {
        flexGrow: 1,
        padding: 4,
        textAlign: "right",
        fontWeight: "bold",
        borderRightWidth: 1,
        borderColor: "#000",
    },

    totalAmount: {
        width: 70,
        padding: 4,
        fontWeight: "bold",
        textAlign: "right",
    },
    projectTotalBox: {
        marginTop: 5,
        borderWidth: 1,
        borderColor: "#000",
        padding: 5,
        backgroundColor: "#f2f2f2",
    },
    projectSummary: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        marginTop: 5,
        fontSize: 10,
        fontWeight: "bold",
    },
    separator: {
        width: "100%",
        height: 1,
        backgroundColor: "#000",
        marginTop: 12,
        marginBottom: 12,
    },
});

/* =========================
   GROUP HELPERS
========================= */

const groupByProject = (rows) => {
    const result = {};
    rows.forEach((r) => {
        if (!result[r.ProjectName]) result[r.ProjectName] = [];
        result[r.ProjectName].push(r);
    });
    return result;
};

const groupByOverhead = (rows) => {
    const result = {};
    rows.forEach((r) => {
        if (!result[r.Overhead]) result[r.Overhead] = [];
        result[r.Overhead].push(r);
    });
    return result;
};

/* =========================
   MAIN PDF
========================= */

const ExpenseprjPDF = ({ data = [], filters = {} }) => {
    const projects = groupByProject(data);

    const formatAmount = (val) =>
        Number(val || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

    const headerPath = filters?.HeaderImg
        ? `${filters.Imageurl}/uploads/images/${filters.HeaderImg}`
        : null;

    const footerPath = filters?.FooterImg
        ? `${filters.Imageurl}/uploads/images/${filters.FooterImg}`
        : null;

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                {/* HEADER */}
                {/* <View fixed style={styles.headerWrapper}>
                    {headerPath ? (
                        <Image src={headerPath} style={styles.headerImage} />
                    ) : (
                        <View style={{ width: "100%", height: 60, backgroundColor: "#eee" }} />
                    )}
                </View> */}

                <Text style={styles.reportTitle}>
                    Expense - Project Based Summary Report
                </Text>

                {Object.entries(projects).map(([projectName, rows], pIndex) => {

                    const filteredRows = rows.filter(
                        (r) => Number(r.Amount || 0) !== 0
                    );

                    const overheads = groupByOverhead(filteredRows);

                    const projectTotal = filteredRows.reduce(
                        (sum, r) => sum + Number(r.Amount || 0),
                        0
                    );

                    const totalTransactions = filteredRows.length;

                    return (
                        <View key={pIndex} style={styles.projectBox}>

                            {/* PROJECT HEADER */}
                            <View style={styles.projectHeader}>
                                <Text>Project : {projectName}</Text>
                            </View>

                            {Object.entries(overheads).map(
                                ([overheadName, oRows], oIndex) => {

                                    const overheadTotal = oRows.reduce(
                                        (sum, r) => sum + Number(r.Amount || 0),
                                        0
                                    );

                                    return (
                                        <View key={oIndex}
                                            // style={styles.overheadBox} 
                                            wrap={false}>

                                            <Text style={styles.overheadTitle}>
                                                Overhead : {overheadName}
                                            </Text>

                                            <View style={styles.table}>

                                                {/* HEADER ROW */}
                                                {/* <View style={styles.tableRow}> */}
                                                <View
                                                    style={[
                                                        styles.tableRow,
                                                        { borderTopWidth: 1, borderColor: "#000" }
                                                    ]}
                                                >
                                                    <Text style={[styles.colSl, styles.tableHeaderText]}>SL#</Text>
                                                    <Text style={[styles.colDate, styles.tableHeaderText]}>Date</Text>
                                                    <Text style={[styles.colComment, styles.tableHeaderText, { textAlign: "center" }]}>Comments</Text>
                                                    <Text style={[styles.colAmount, styles.tableHeaderText]}>Amount</Text>
                                                </View>

                                                {oRows.map((r, i) => (
                                                    <View key={i} style={styles.tableRow}>
                                                        <Text style={styles.colsSl}>{i + 1}</Text>
                                                        <Text style={styles.colsDate}>{r.FEDate}</Text>
                                                        <Text style={styles.colsComment}>
                                                            {r.Comments || "-"}
                                                        </Text>
                                                        <Text style={styles.colsAmount}>
                                                            {formatAmount(r.Amount)}
                                                        </Text>
                                                    </View>
                                                ))}

                                                {/* OVERHEAD TOTAL */}
                                                <View style={styles.totalRow}>
                                                    <Text style={styles.totalLabel}>
                                                        Total
                                                    </Text>
                                                    <Text style={styles.totalAmount}>
                                                        {formatAmount(overheadTotal)}
                                                    </Text>
                                                </View>

                                            </View>
                                        </View>
                                    );
                                }
                            )}

                            {/* PROJECT TOTAL */}
                            <View style={styles.projectSummary}>
                                <Text>Project Name : {projectName}</Text>
                                <Text>Transaction Count : {formatAmount(totalTransactions)}</Text>
                                <Text>Total Amount : {formatAmount(projectTotal)}</Text>
                            </View>
                            <View style={styles.separator} />


                        </View>
                    );
                })}

                {/* FOOTER */}
                {/* {footerPath && (
                    <View fixed style={styles.footerWrapper}>
                        <Image src={footerPath} style={styles.footerImage} />
                    </View>
                )} */}

            </Page>
        </Document>
    );
};

export default ExpenseprjPDF;